import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { usePremiumUi } from './usePremiumUi';

type SectionHeaderProps = {
  title: string;
  subtitle?: string;
  rightContent?: React.ReactNode;
};

export const SectionHeader = ({ title, subtitle, rightContent }: SectionHeaderProps) => {
  const premiumUi = usePremiumUi();
  return (
    <Box
      mb={2}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      gridGap={10}
    >
      <Box>
        <Typography variant="h6" style={premiumUi ? { letterSpacing: '0.01em' } : undefined}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="textSecondary">
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {rightContent ? <Box>{rightContent}</Box> : null}
    </Box>
  );
};

